import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-QAList",
  "use": "icon-QAList-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-QAList\"><path d=\"M910.222222 56.888889a113.777778 113.777778 0 0 1 113.777778 113.777778v510.293333a113.777778 113.777778 0 0 1-113.777778 113.777778H219.534222l-159.459555 186.197333A34.133333 34.133333 0 0 1 0 958.748444V170.666667a113.777778 113.777778 0 0 1 113.777778-113.777778h796.444444z m-113.379555 298.097778a69.632 69.632 0 1 0 0 139.207111 69.632 69.632 0 0 0 0-139.264z m-283.591111-9.671111a69.632 69.632 0 1 0 0 139.264 69.632 69.632 0 0 0 0-139.264z m-286.094223-3.299556a69.632 69.632 0 1 0 0 139.264 69.632 69.632 0 0 0 0-139.264zM1024 933.432889c0 43.235556-35.100444 78.392889-78.392889 78.392889H266.183111a78.392889 78.392889 0 0 1 0-156.842667h679.424c43.235556 0 78.392889 35.100444 78.392889 78.449778z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/QAList.svg
// module id = QSs5
// module chunks = 78